var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MouseIcon } from '@patternfly/react-icons';
import { Chip } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
const symbols = {
    'shift': '⇧',
    'opt': '⌥',
    'cmd': '⌘',
    'enter': '↵',
    'ctrl': '^',
    'caps lock': '⇪',
    'tab': '↹',
    'win': '⊞',
    'backspace': '⌫'
};
const useStyles = createUseStyles({
    shortcut: {
        marginRight: 'var(--pf-v5-global--spacer--lg)'
    }
});
const Shortcut = (_a) => {
    var { keys = [], description = null, showSymbols = true, hover, click, drag, rightClick, dragAndDrop, className, ouiaId = 'Shortcut' } = _a, props = __rest(_a, ["keys", "description", "showSymbols", "hover", "click", "drag", "rightClick", "dragAndDrop", "className", "ouiaId"]);
    const classes = useStyles();
    const badges = [
        ...(hover ? [
            React.createElement(Chip, { key: "hover", isReadOnly: true, "data-test-id": "hover" },
                React.createElement(MouseIcon, null),
                " Hover")
        ] : []),
        ...keys.map((key) => {
            const trimmedKey = key.trim().toLowerCase();
            return (React.createElement(Chip, { key: key, isReadOnly: true, "data-test-id": `${key}-key` },
                showSymbols && symbols[trimmedKey] ? `${symbols[trimmedKey]} ` : '',
                key.length === 1 ? key.toUpperCase() : key[0].toUpperCase() + key.slice(1).toLowerCase()));
        }),
        ...(click ? [
            React.createElement(Chip, { key: "click", isReadOnly: true, "data-test-id": "click" },
                React.createElement(MouseIcon, null),
                " Click")
        ] : []),
        ...(rightClick ? [
            React.createElement(Chip, { key: "right-click", isReadOnly: true, "data-test-id": "right-click" },
                React.createElement(MouseIcon, null),
                " Right click")
        ] : []),
        ...(drag ? [
            React.createElement(Chip, { key: "drag", isReadOnly: true, "data-test-id": "drag" },
                React.createElement(MouseIcon, null),
                " Drag")
        ] : []),
        ...(dragAndDrop ? [
            React.createElement(Chip, { key: "drag-and-drop", isReadOnly: true, "data-test-id": "drag-and-drop" },
                React.createElement(MouseIcon, null),
                " Drag + Drop")
        ] : [])
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("span", Object.assign({ className: clsx({ [classes.shortcut]: description, className }), "data-ouia-component-id": ouiaId }, props), badges.length > 0 && badges.reduce((prev, curr) => (React.createElement(React.Fragment, null, [prev, ' + ', curr])))),
        description));
};
export default Shortcut;
